import { FormattedMessage } from 'react-intl'
import { keepPreviousData } from '@tanstack/react-query'

import { Accordion } from '@gto/ui/accordion'
import { useMediaQuery } from '@gto/ui/hooks/use-media-query'
import { Typography } from '@gto/ui/typography'

import { useFaqList } from '@/api/gen'
import { Loader } from '@/components/loader'
import { SupportLinksCard } from '@/components/support-links-card'

export const RootRoute = () => {
  const isSmAndLower = useMediaQuery('down', 'sm')
  const { data, isFetching } = useFaqList({
    query: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 10,
      placeholderData: keepPreviousData,
    },
  })

  return (
    <div className="flex flex-col gap-8 sm:gap-6">
      <Typography
        gutterBottom
        component="h1"
        variant={isSmAndLower ? 'h5' : 'h4'}
      >
        <FormattedMessage id="common.labels.frequentlyAskedQuestions" />
      </Typography>

      {isFetching ? (
        <Loader />
      ) : (
        <div>
          {data?.map((faq) => (
            <Accordion.Root
              key={faq.question}
              className="mb-4"
              variant="card"
            >
              <Accordion.Trigger>
                <Typography
                  className="min-w-0"
                  color="text.primary"
                  component="span"
                  variant="subtitle1"
                >
                  {faq.question}
                </Typography>
              </Accordion.Trigger>
              <Accordion.Content>
                <Typography
                  className="whitespace-pre-line"
                  color="text.secondary"
                  component="span"
                  variant="body1"
                >
                  {faq.answer}
                </Typography>
              </Accordion.Content>
            </Accordion.Root>
          ))}
        </div>
      )}

      <SupportLinksCard />
    </div>
  )
}
